import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { BRAND, WHATSAPP_URL } from "@/constants";
import { TikTokIcon, WhatsAppIcon } from "@/components/icons";

export const Footer = () => (
  <footer className="bg-beige border-t border-sand" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-14 grid gap-10 md:grid-cols-3">
      <div>
        <img
          src="/images/logo.png"
          alt="Logótipo da Doce Casa"
          className="h-16 w-auto"
        />
        <p className="mt-4 font-hand text-2xl text-caramel">{BRAND.slogan}</p>
        <p className="mt-2 text-sm text-cocoa" data-testid="footer-area">{BRAND.area}</p>
      </div>

      <div>
        <h2 className="font-serif text-lg font-semibold text-chocolate">Segue-nos</h2>
        <div className="mt-4 flex items-center gap-3">
          <span
            title="Instagram — em breve"
            data-testid="footer-instagram-link"
            className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-white border border-sand text-chocolate shadow-sm"
          >
            <Instagram className="w-5 h-5" />
            <span className="sr-only">Instagram (em breve)</span>
          </span>
          <span
            title="TikTok — em breve"
            data-testid="footer-tiktok-link"
            className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-white border border-sand text-chocolate shadow-sm"
          >
            <TikTokIcon className="w-5 h-5" />
            <span className="sr-only">TikTok (em breve)</span>
          </span>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            title="WhatsApp"
            data-testid="footer-whatsapp-link"
            className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-white border border-sand text-chocolate shadow-sm transition-colors duration-200 hover:bg-caramel hover:text-cream"
          >
            <WhatsAppIcon className="w-5 h-5" />
            <span className="sr-only">WhatsApp</span>
          </a>
        </div>
        <p className="mt-4 text-sm text-cocoa">Encomendas sujeitas a disponibilidade.</p>
      </div>

      <div>
        <h2 className="font-serif text-lg font-semibold text-chocolate">Informações</h2>
        <ul className="mt-4 space-y-2 text-sm">
          <li>
            <Link to="/privacidade" data-testid="footer-privacy-link" className="text-cocoa transition-colors hover:text-caramel">
              Política de Privacidade
            </Link>
          </li>
          <li>
            <Link to="/termos" data-testid="footer-terms-link" className="text-cocoa transition-colors hover:text-caramel">
              Termos e Condições
            </Link>
          </li>
          <li>
            <Link to="/alergenios" data-testid="footer-allergens-link" className="text-cocoa transition-colors hover:text-caramel">
              Informação sobre alergénios
            </Link>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-sand">
      <p className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-5 text-center text-xs text-cocoa" data-testid="footer-copyright">
        © {new Date().getFullYear()} Doce Casa. Todos os direitos reservados.
      </p>
    </div>
  </footer>
);
